export const typography = {
  fontFamily: "'Noto Sans Thai Variable', sans-serif",
  // Headings - Primary hierarchy for page titles and sections
  h1: {
    fontSize: "2.5rem", // 40px
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: "-0.01em",
  },
  h2: {
    fontSize: "2rem", // 32px
    fontWeight: 700,
    lineHeight: 1.25,
    letterSpacing: "-0.005em",
  },
  h3: {
    fontSize: "1.75rem", // 28px
    fontWeight: 600,
    lineHeight: 1.3,
  },
  h4: {
    fontSize: "1.5rem", // 24px
    fontWeight: 600,
    lineHeight: 1.35,
  },
  h5: {
    fontSize: "1.25rem", // 20px
    fontWeight: 600,
    lineHeight: 1.4,
  },
  h6: {
    fontSize: "1rem", // 16px
    fontWeight: 600,
    lineHeight: 1.5,
  },
  // Subtitles - Secondary hierarchy for subheadings
  subtitle1: {
    fontSize: "1rem", // 16px
    fontWeight: 500,
    lineHeight: 1.5,
    letterSpacing: "0.00938em",
  },
  subtitle2: {
    fontSize: "0.875rem", // 14px
    fontWeight: 500,
    lineHeight: 1.57,
    letterSpacing: "0.00714em",
  },
  // Body text - Primary content
  body1: {
    fontSize: "1rem", // 16px
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: "0.00938em",
  },
  body2: {
    fontSize: "0.875rem", // 14px
    fontWeight: 400,
    lineHeight: 1.57,
    letterSpacing: "0.01071em",
  },
  // UI elements
  button: {
    fontSize: "0.875rem", // 14px
    fontWeight: 500,
    lineHeight: 1.75,
    letterSpacing: "0.02857em",
    textTransform: "none" as const,
  },
  caption: {
    fontSize: "0.75rem", // 12px
    fontWeight: 400,
    lineHeight: 1.66,
    letterSpacing: "0.03333em",
  },
  overline: {
    fontSize: "0.75rem", // 12px
    fontWeight: 500,
    lineHeight: 2.66,
    letterSpacing: "0.08em",
    textTransform: "uppercase" as const,
  },
};
